import { Breadcrumb, Button, Input, Radio, Select } from 'antd';
import React, { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import ReCAPTCHA from "react-google-recaptcha";
import { Link, useHistory } from 'react-router-dom';
import clienteAxios from '../../../configAxios/configAxios';
import iconCorrect from '../../../img/Iconos/icon_correct.svg';
import iconIncorrect from '../../../img/Iconos/icon_incorrect.svg';
import { errorSwal, succesSwal } from '../../../helper/swalHelpers';
import { checkIsNotEmpty, formateaRut, tipeoNumero, tipeoRut, validarNumero, validarRut, validateEmail } from '../../../helper/validations';
import { useComunas, useRegiones, useValidaciones } from '../../../hooks/Front/formularios/useFormularios';
import Footer from '../../components/foter/footer';
import Navbar from '../../components/navbar/navbar';
import Seo from '../../components/seo/seo';
import './contactanos.css'

const { TextArea } = Input;
const { Option } = Select;

const Contactanos = () => {
    
    const history = useHistory();

    const [formulario, setFormulario] = useState({
        Modulo: "CONTACTANOS",
        tipoSolicitud: undefined,
        Rut: "",
        Nombre: "",
        Apellidos: "",
        Telefono: "",
        Email: "",
        Region: undefined,
        Comuna: undefined,
        Mensaje: ""
    })

    const { regiones, loading: loadingR } = useRegiones();
    const { comunas, loading: loadingC } = useComunas(formulario.Region);

    const [validar, setValidar] = useState({ name: undefined, value: undefined });

    const [validaciones] = useValidaciones(validar, formulario);
    const [loadingPeticion,setLoadingPeticion] = useState(false);
    const [captcha, setCaptcha] = useState(null);

    const handleChange = (e) => {
        setFormulario({ ...formulario, [e.target.name]: e.target.value });
    };

    const clearFormulario = () => {
        setFormulario({
            Modulo: "CONTACTANOS",
            tipoSolicitud: undefined,
            Rut: "",
            Nombre: "",
            Apellidos: "",
            Telefono: "",
            Email: "",
            Region: undefined,
            Comuna: undefined,
            Mensaje: ""
        })
    }

    const changeInput = (e) => {
        setValidar({ name: e.target.name, value: e.target.value });
    }

    function onChangeCaptcha(value) {
        setCaptcha(value);
    }

    const redirectToHome = () => {
        history.push("/")
    }

    const enviarFormulario = async () => {
        try {            
            setLoadingPeticion(true);
            let response =await clienteAxios.post('crearSolicitud', formulario);
            setLoadingPeticion(false);
            if(response.status === 201){
                clearFormulario();
                succesSwal("Formulario enviado exitosamente", "Nos comunicaremos contigo a la brevedad", "Volver a home", redirectToHome);
                return;
            }
            errorSwal("¡Algo ha fallado!", "Por favor vuelve a intentarlo", "Volver a intentar");
        } catch (error) {
            setLoadingPeticion(false);
            errorSwal("¡Algo ha fallado!", "Por favor vuelve a intentarlo", "Volver a intentar");
        }
    }

    const changeSelects = (nombre, value) => {
        if (nombre === "Region") {
            setFormulario({ ...formulario, [nombre]: value, comuna: undefined })
            return
        };
        setFormulario({ ...formulario, [nombre]: value })
    }

    const blurSelects = (nombre, value) => {
        setValidar({ name: nombre, value: value });
    }

    const handleSubmit = () => {
        if (!validarRut(formulario.Rut) ||
            !validarNumero(formulario.Telefono) ||
            !validateEmail(formulario.Email) ||
            !checkIsNotEmpty(formulario.Nombre) ||
            !checkIsNotEmpty(formulario.Apellidos) ||
            !checkIsNotEmpty(formulario.Region) ||
            !checkIsNotEmpty(formulario.Comuna) ||
            !checkIsNotEmpty(formulario.Mensaje) ||
            !checkIsNotEmpty(formulario.tipoSolicitud) ||
            !captcha
        ) {
            errorSwal("Ocurrió un error", "Recuerda ingresar todos los campos requeridos.", "Ok");
            return
        }
        enviarFormulario();
    }


    const IconoInput = (nombre) => {
        if (nombre === undefined || nombre.length < 1) return null;
        else if (nombre === "formulario-success") return <img src={iconCorrect} alt="icon" />;
        else return <img src={iconIncorrect} alt="icon" />
    }

    return (
        <>
            <Navbar />
            <Seo title="Contáctanos -" />
            <main>
                <Container className="contactanos-container" fluid>
                    <Row>
                        <Col className="my-4">
                            <Breadcrumb separator=">" className="parrafo-hyundai f-responsive-10">
                                <Breadcrumb.Item>
                                    <Link to='/'>
                                        Home
                                    </Link>
                                </Breadcrumb.Item>
                                <Breadcrumb.Item>
                                    Contáctanos
                                </Breadcrumb.Item>
                            </Breadcrumb>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} className="text-center my">
                            <h1 className="bold-title-hyundai mb-1 f-responsive-14">Contáctanos</h1>
                            <h6 className="bold-title-hyundai mb-3 mb-md-5 f-responsive">¿En qué te podemos ayudar?</h6>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={9} lg={8} xl={6} className="mx-auto bg-white container-inputs mb-general">
                            <Row>
                                <Col xs={12} className="my-4 mt-5">
                                    <Radio.Group value={formulario.tipoSolicitud} name="tipoSolicitud" onChange={handleChange} className="w-100 ">
                                        <Row>
                                            <Col xs={6} md={3} className="text-center">
                                                <Radio value="denuncia"><p className="d-block d-md-inline font-check-con f-responsive">Denuncias</p></Radio>
                                            </Col>

                                            <Col xs={6} md={3} className="text-center">
                                                <Radio value="sugerencia"><p className="d-block d-md-inline font-check-con f-responsive">Sugerencias</p></Radio>
                                            </Col>

                                            <Col xs={6} md={3} className="text-center">
                                                <Radio value="reclamo"><p className="d-block d-md-inline font-check-con f-responsive">Reclamos</p></Radio>
                                            </Col>
                                            <Col xs={6} md={3} className="text-center">
                                                <Radio value="felicitaciones"><p className="d-block d-md-inline font-check-con f-responsive">Felicitaciones</p></Radio>
                                            </Col>
                                        </Row>
                                    </Radio.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col className="px-0">
                                    <hr className="hr-contactanos" />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={11} md={9} lg={8} xl={7} className="mx-auto mt-md-5 mb-3">
                                    <Label texto="Rut" />
                                    <Input
                                        className={`contacto-input ${validaciones.Rut}`}
                                        name="Rut"
                                        onChange={(e) => {
                                            let rutformat = formateaRut(e.target.value, "puntos");
                                            if (e.target.value.length > 1) {
                                                setFormulario({ ...formulario, Rut: rutformat });
                                            } else {
                                                setFormulario({ ...formulario, Rut: e.target.value });
                                            }
                                        }}
                                        suffix={IconoInput(validaciones.Rut)}
                                        onBlur={changeInput} onKeyPress={(e) => tipeoRut(e)} value={formulario.Rut} ></Input>
                                    {validaciones.Rut === "error-formulario" && <p className="texto-error-input f-responsive">No olvides ingresar un Rut válido</p>}
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={11} md={9} lg={8} xl={7} className="mx-auto mb-3">
                                    <Label texto="Nombre" />
                                    <Input className={`contacto-input ${validaciones.Nombre}`} onChange={handleChange} suffix={IconoInput(validaciones.Nombre)} value={formulario.Nombre} name="Nombre" onBlur={changeInput}></Input>
                                    {validaciones.Nombre === "error-formulario" && <p className="texto-error-input f-responsive">No olvides ingresar tu nombre</p>}
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={11} md={9} lg={8} xl={7} className="mx-auto mb-3">
                                    <Label texto="Apellido" />
                                    <Input className={`contacto-input ${validaciones.Apellidos}`} value={formulario.Apellidos} suffix={IconoInput(validaciones.Apellidos)} onChange={handleChange} name="Apellidos" onBlur={changeInput}></Input>
                                    {validaciones.Apellidos === "error-formulario" && <p className="texto-error-input f-responsive">No olvides ingresar tu apellido</p>}
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={11} md={9} lg={8} xl={7} className="mx-auto mb-3">
                                    <Label texto="Teléfono" />
                                    <Input className={`contacto-input ${validaciones.Telefono}`} value={formulario.Telefono} maxLength={8} suffix={IconoInput(validaciones.Telefono)} onChange={handleChange} prefix="+569" name="Telefono" onKeyPress={e => tipeoNumero(e)} onPaste={e => e.preventDefault()} onBlur={changeInput}></Input>
                                    {validaciones.Telefono === "error-formulario" && <p className="texto-error-input f-responsive">No olvides ingresar un teléfono válido</p>}
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={11} md={9} lg={8} xl={7} className="mx-auto mb-3">
                                    <Label texto="Email" />
                                    <Input className={`contacto-input ${validaciones.Email}`} value={formulario.Email} suffix={IconoInput(validaciones.Email)} onChange={handleChange} name="Email" onBlur={changeInput}></Input>
                                    {validaciones.Email === "error-formulario" && <p className="texto-error-input f-responsive">Verifica que tú email contenga @ y .</p>}
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={11} md={9} lg={8} xl={7} className="mx-auto mb-3">
                                    <Label texto="Región" />
                                    <Select placeholder="Selecciona" name="Region" loading={loadingR} value={formulario.Region} onChange={e => changeSelects("Region", e)} className="contacto-select w-100" onBlur={() => blurSelects("Region", formulario.Region)} >
                                        {regiones && regiones.length > 0 && regiones.map((region, index) =>
                                            <Option key={index} value={region.idRegion}>{region.Region}</Option>
                                        )}
                                    </Select>
                                    {validaciones.Region === "error-formulario" && <p className="texto-error-input f-responsive">No olvides ingresar la región</p>}
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={11} md={9} lg={8} xl={7} className="mx-auto mb-3">
                                    <Label texto="Comuna" />
                                    <Select placeholder="Selecciona" value={formulario.Comuna} disabled={!comunas ? true : comunas.length < 1 ? true : false} onChange={e => changeSelects("Comuna", e)} onBlur={() => blurSelects("Comuna", formulario.Comuna)} className="contacto-select w-100">
                                        {comunas && comunas.length > 0 &&
                                            comunas.map((comuna, i) =>
                                                <Option key={i} value={comuna.idComuna}>{comuna.Comuna}</Option>
                                            )
                                        }
                                    </Select>
                                    {validaciones.Comuna === "error-formulario" && <p className="texto-error-input f-responsive">No olvides ingresar la comuna</p>}
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={11} md={9} lg={8} xl={7} className="mx-auto mb-4">
                                    <Label texto="Mensaje" />
                                    <TextArea maxLength={250} value={formulario.Mensaje} onChange={handleChange} onBlur={changeInput} name="Mensaje" className={`contacto-input ${validaciones.Mensaje}`} autoSize={{ minRows: 3, maxRows: 3 }} />
                                    {validaciones.Mensaje === "error-formulario" && <p className="texto-error-input f-responsive">No olvides dejar tu mensaje</p>}
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={"auto"} md={"auto"} className="mx-auto mb-4">
                                    <ReCAPTCHA
                                        sitekey={process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY}
                                        onChange={onChangeCaptcha}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={11} md={9} lg={8} xl={7} className="mx-auto text-center mb-btn">
                                    <Button className="btn-primario font-btn w-100" onClick={handleSubmit} disabled={loadingPeticion} loading={loadingPeticion}>Enviar</Button>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </main>
            <Footer />
        </>
    );
};

export const Label = ({ texto, optional }) => <p className="parrafo-hyundai mb-1 f-responsive">{texto} {!optional && <span className="requerido-form">*</span> }</p>;
export default Contactanos;